<template>
    <base-modal-focus-lock :show-modal="showModal">
        <transition name="cz3__fade">
            <div
                v-if="showModal"
                @click.self="emitClose"
                class="z-[100] fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
            >
                <div class="shadow-md w-11/12 max-w-md py-[36px] px-[24px] sm:p-9 bg-white font-oceanside text-black text-center">
                    <h1 class="mb-[16px] text-[21px] leading-[24px] font-semibold">
                        {{ modalHeading }}
                    </h1>

                    <p class="mb-[20px] text-[16px] leading-5">
                        {{ modalCopy }}
                    </p>

                    <div class="flex flex-col items-center lg:flex-row justify-center gap-[16px]">
                        <base-button-flat
                            v-if="showCancelButton"
                            @click="emitClose"
                            variant="secondary"
                            class="w-full lg:w-3/4 max-w-[300px] h-[36px] capitalize text-[16px] leading-tight"
                        >
                            {{ cancelButtonCopy }}
                        </base-button-flat>

                        <base-button-flat
                            @click="emitConfirm"
                            class="w-full lg:w-3/4 max-w-[300px] h-[36px] capitalize text-[16px] leading-tight"
                            variant="tertiary"
                        >
                            {{ ctaCopy }}
                        </base-button-flat>
                    </div>
                </div>
            </div>
        </transition>
    </base-modal-focus-lock>
</template>

<script>
    import BaseModalFocusLock from './BaseModalFocusLock.vue';
    import BaseButtonFlat from './buttons/BaseButtonFlat.vue';

    export default {
        components: {
            BaseButtonFlat,
            BaseModalFocusLock,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            modalHeading: {
                type: String,
                default: '',
            },
            modalCopy: {
                type: String,
                default: '',
            },
            ctaCopy: {
                type: String,
                required: true,
            },
            cancelCopy: {
                type: String,
                default: '',
            },
            showCancelButton: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            cancelButtonCopy() {
                return this.cancelCopy ? this.cancelCopy : `${this.$t('CANCEL')}`;
            },
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },

            emitConfirm() {
                this.$emit('confirmAndExit');
            },
        },
    };
</script>
